// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Restaurer la session depuis localStorage
    const token    = localStorage.getItem('kindeo_token');
    const userData = localStorage.getItem('kindeo_user');
    if (token && userData) {
      try {
        setUser(JSON.parse(userData));
      } catch {
        localStorage.removeItem('kindeo_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
  const res = await api.post('/auth/login', { email, password });
  const { token, user: userData } = res.data;
  localStorage.setItem('kindeo_token', token);
  localStorage.setItem('kindeo_user', JSON.stringify(userData));
  setUser(userData);
  return userData;
};
  

  const register = async (formData) => {
    const res = await api.post('/auth/register', formData);
    const { token, user: userData } = res.data;
    localStorage.setItem('kindeo_token', token);
    localStorage.setItem('kindeo_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('kindeo_token');
    localStorage.removeItem('kindeo_user');
    setUser(null);
  };

  const updateUser = (newData) => {
  const updated = { ...user, ...newData };
  localStorage.setItem('kindeo_user', JSON.stringify(updated));
  setUser(updated);
};

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
